<template>
  <div class="referral-resolve"></div>
</template>

<script>
export default {
  name: "ReferralResolveView",
  created() {
    const slug = String(this.$route.params.referralSlug || "").trim();
    if (this.$store.state.Auth?.user?.token) {
      this.$router.replace({ name: "dashboard" });
      return;
    }
    if (!slug) {
      this.$router.replace({ name: "login" });
      return;
    }
    this.$router.replace({ name: "signup", query: { ref: slug } });
  },
};
</script>
